<template>
  <tr
    class="settings-summary-item"
    :data-cy-summary-item-name="setCyName(item)"
  >
    <td
      class="settings-summary-item-name ibf-text-list2"
      :data-cy-summary-item-value="item.Val"
      @click="e => $emit('click', e)"
    >
      {{ item.Name }}
    </td>
    <td
      v-if="isBoolean(item.Val)"
      :data-cy-summary-item="item.Val"
      class="settings-summary-item-value summary-item-boolean ibf-amount6"
    >
      <q-icon
        style="font-size: 12px"
        :name="getCheckIcon(item.Val)"
      />
    </td>
    <td
      v-else
      class="settings-summary-item-value align-end ibf-amount6"
    >
      <div v-if="!item.Val">--</div>
      <div v-else-if="item.epoch">
        {{ _.appContext.config.globalProperties.$filters.formatDateUnix(item.Val, item.epoch) }}
      </div>
      <div v-else>{{ item.Val }} {{ item.addedLabel || '' }}</div>
    </td>
  </tr>
</template>

<script>
import { defineComponent } from 'vue';
import elementsIds from '@/const/elementIds.json';

export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      elementsIds,
    };
  },
  methods: {
    isBoolean(obj) {
      return typeof obj === 'boolean';
    },
    getCheckIcon(obj) {
      if (obj) return 'icon-check-v';
      return 'icon-x-small';
    },
    setCyName(item) {
      return `settings-summary-item-${item.Name.toLowerCase().replaceAll(/ /g, '-').replaceAll('"', '').replaceAll('/', '-')}`;
    },
  },
});
</script>

<style lang="scss" scoped>
.align-end {
  text-align: end;
}
.settings-summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .summary-item-boolean {
    display: flex;
    width: 50px;
    align-items: center;
    margin-top: 4px;
    justify-content: flex-end;
    i {
      &::before {
        color: $-text-text-medium;
      }
    }
    .icon-x-small {
      font-size: 10px !important;
    }
  }
  .settings-summary-item-name {
    color: $-text-text-low;
    font-size: 11px;
    font-family: Gordita-Regular;
    font-weight: 400;
  }
  .settings-summary-item-value {
    color: $-text-text-high;
    .q-icon {
      margin-left: 12px;
    }
  }
}
</style>
